<template>
  <div class="hello">
    <div id="subheader" class="container">
      <div id="sub_content">
          <div id="thumb">
            <router-link to="/">
            <img src="/img/logo.svg" alt="" class="img-responsive" style="width:80%"></router-link></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainLogo'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
